<div class="contentContainer">
	<main class="contentContainer-main">
		<div class="departmentContainer" *ngFor="let department of departments; trackBy: trackByDepartments">
			<a
				data-cy="departmentList"
				[routerLink]="buildDepartmentUrl(department)"
				[cdxTrackEvent]="{
					event: trackingEvent.NotificationEvent,
					type: notificationType.Global,
					name: 'Browse',
					value: department.url
				}"
			>
				<strong data-cy="departmentLabel">{{ department.label }}</strong>
				<cdx-svg-icon name="chevron-right" fill="green" size="extra-small"></cdx-svg-icon>
			</a>
			<div data-cy="aisle" class="facetContainer">
				<div class="facetScroller">
					<button
						data-cy="aisleLabel"
						cdxButton
						fillStyle="outline"
						[routerLink]="buildDepartmentUrl(department, facet)"
						[cdxTrackEvent]="{
							event: trackingEvent.NotificationEvent,
							type: notificationType.Global,
							name: 'Browse',
							value: buildDepartmentTrackingName(department, facet)
						}"
						*ngFor="let facet of department.dasFacets; trackBy: trackByFacet"
					>
						{{ facet.name | titlecase }}
					</button>
				</div>
			</div>
		</div>
	</main>
</div>
